module.exports = __webpack_public_path__ + "img/pie-chart.79e69ed3.svg";